import { Injectable, Inject } from '@angular/core';
import {environment} from '../environments/environment'
import { Headers, Http, Response } from '@angular/http';
import 'rxjs/Rx';
import { Observable,Subject } from 'rxjs';
declare var Noty: any;


@Injectable()
export class DataService {
isConnected:Observable<boolean>
  constructor(
    private http : Http,
    //private headers = new Headers({'Content-Type': 'application/json'})
  ) {

  }
  // serviceUrl = environment.serviceUrl;
  newServiceUrl=environment.newServiceUrl;
  footer40=environment.footer40;
  newfooter40 = this.footer40;
  serviceUrl = this.newServiceUrl;
  
  // footer400 = this.footer40;
  // footer40:false
  public storageSub= new Subject<string>();
  public companyDataSub=new Subject<string>();
  public searchsub=new Subject<string>();
  public pixelSub =  new Subject<string>();


 //Thakur: 24Aug17 for get coaching module
  getCoachingModule(inputData){
    const headers = new Headers({'Content-Type': 'application/json'})
    return this.http.post(this.serviceUrl+'/CoachingModuleChapter',
    inputData,{headers: headers})
    .map(
      (response: Response) => {
        const data = response.json();
        return data;
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  getUserPendingCompletedModule(inputData){
    const headers = new Headers({'Content-Type': 'application/json'})
    return this.http.post(this.serviceUrl+'/GetUserModuleDetailsById',
    inputData,{headers: headers})
    .map(
      (response: Response) => {
        const data = response.json();
        return data;
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }
  getModuleDetail(inputData){
    const headers = new Headers({'Content-Type': 'application/json'})
    return this.http.post(this.serviceUrl+'/GetModuleDetailsV4',
    inputData,{ headers: headers})
    .map(
      (response:Response)=>{
       // console.log(response);
        return response.json();
      }
    ).catch(
      (error)=>{
        return error;
      }
    )
  }

  SaveModuleDtails(inputData){
    const headers = new Headers({'Content-Type': 'application/json'})
    return this.http.post(this.serviceUrl+'/SaveModuleDtailsForLanding',
    inputData,{ headers: headers})
    .map(
      (response:Response)=>{
        return response.json();
      }
    ).catch(
      (error)=>{
        return error;
      }
    )
  }

  //Thakur: 1 Sep 17
  checkHappCoachUserById(inputData){
    const headers = new Headers({'Content-Type': 'application/json'});
    return this.http.post(this.serviceUrl+'/CheckHappCoachUserById',
    inputData,{
      headers: headers
    })
    .map(
      (response: Response)=> {
        return response.json();
      }
    )
    .catch(
      (error)=>{
        return error;
      })
  }

  //Thakur: 1 Sep17
  assignModuleToUser(inputData){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/AssignModuleToUser',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }
  updateReflection(inputData){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/UpdateRefltection',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  };
  //Thakur 15 Sep 17 Method for make payment for plan
  PaymentForModule(inputData){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/PaymentForModule',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  alert(msg, type){
  var n = new Noty({
      theme:'stratgist',
      text: '<strong>'+ msg +'</strong>',
      type   : type,

      progressBar: true,
      closeWith: ['click', 'button'],
      timeout:2000

    }).show();
    Noty.setMaxVisible(1,'notification');

  }

  alertMessage(msg, type,time?){
    let timeFixed=time;
    if(timeFixed==undefined){
      timeFixed=2000
    }
    var n = new Noty({
        theme:'stratgist',
        text: '<strong>'+ msg +'</strong>',
        type   : type,

        progressBar: true,
        closeWith: ['click', 'button'],
        timeout:timeFixed

      }).show();
      Noty.setMaxVisible(1,'notification');

  }

  //Thakur: - 6Nov2017
  HappCoachServices: any = "http://www.happcoach.com/Service/HappCoachServices";
  // HappCoachServices: any = "http://happcoach.com/serviceTest/HappCoachServices";
  applyCoupon(inputData){
   // console.log(this.newServiceUrl+'/ApplyCouponCode');
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/ApplyCouponCode',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  AddBookmark(inputData){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/AddBookmark',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  ClickOnPaidModule(inputData){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/ClickOnPaidModule',
    inputData,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetQusetionData(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/GetQusetionData',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetReflectById(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/GetReflectById',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetResultData(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/GetResultData',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetChapterData(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/GetChapterData',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  getModuleDetailv2(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.serviceUrl+'/GetModuleDetailsV2',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  SignUpUser(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/SignUpUser',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  LoginUser(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/LoginUserNew',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  LoginUser2(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/LoginUser2',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetAllThemes(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetAllThemes',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  AddUserDetails(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/AddUserDetails',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetDashBoardModule(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetDashBoardModule',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetDashBoardModuleV2(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetDashBoardModuleV2',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetSearchModule(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetSearchModule',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  ThemeModuleByUser(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/ThemeModuleByUser',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  Getgoals(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/Getgoals',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  AssignGoal(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/AssignGoal',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

GetPlan(){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.get(this.newServiceUrl+'/GetPlan',
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetModuleUserQuesn(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetModuleUserQuesn',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  UpdateModuleUserQuesn(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/UpdateModuleUserQuesn',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  ForgetPassword(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/ForgetPassword',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  ContactUs(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/ContactUs',
    inputJson,{
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }



   AddUserLog(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/AddUserLog',
     inputJson,{
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   ListOfFAQ(){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.get(this.newServiceUrl+'/ListOfFAQ',
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   UpdateUserCount(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/UpdateUserCount',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   watchStorage():Observable<any>{
     return this.storageSub.asObservable();
   }

   GetBullEye(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetBullEye',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   GetUserDetailById(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetUserDetailById',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   GetAllTheme(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetAllTheme', inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   ResetPassword(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/ResetPassword',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   UpdateUserDetails(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/UpdateUserDetails',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   RequestForEnterprise(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/RequestForEnterprise',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   GetSubScribeUser(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetSubScribeUser',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   UpdateUserPassword(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/UpdateUserPassword',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   GetAllThemesForSite(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetAllThemesForSite', inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   GetUserPlanId(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/GetUserPlanId',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   CreateTestUser(){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.get(this.newServiceUrl+'/CreateTestUser',
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   AddUserFromlandingPaymentPage(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/AddUserFromlandingPaymentPage',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

   CheckEmail(inputJson){
     const header = new Headers({"Content-Type": "application/json"})
     return this.http.post(this.newServiceUrl+'/CheckEmail',inputJson,
     {
       headers: header
     })
     .map(
       (response: Response)=>{
         return response.json()
       }
     )
     .catch(
       (error)=>{
         return error;
       }
     )
   }

  GetPlanV2(){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.get(this.newServiceUrl+'/GetPlanV2',
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  SignUpUserV2(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/SignUpUserV2',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetDashBoardModuleV3(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetDashBoardModuleV3',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  } 

  GetDashBoardAdvModule(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetDashBoardAdvModule',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  MasterClass(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/MasterClass',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  SignUpUserV3ForLandingPage(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/SignUpUserV3ForLandingPage',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

  GetHomeTheme(inputJson){
    const header = new Headers({"Content-Type": "application/json"})
    return this.http.post(this.newServiceUrl+'/GetHomeTheme',inputJson,
    {
      headers: header
    })
    .map(
      (response: Response)=>{
        return response.json()
      }
    )
    .catch(
      (error)=>{
        return error;
      }
    )
  }

   watchCompanyData():Observable<string>{
     return this.companyDataSub.asObservable()
   }

   watchSearchSub(){
     return this.searchsub.asObservable();
   }

   watchPixel(){
     return this.pixelSub.asObservable();
   }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/data.service.ts